<template>
    <div id="Header">
        <div class="header login-header" v-if="From=='Login'">
            <div class="row">
                <div class="col-12 logo">
                    <img src="/img/logo.png" alt="">
                    <!-- <button @click="$router.push('/admin/login')" class="centered button-outlined">Admin Login</button> -->
                    <button class=" button-outlined" @click="$router.push('/shop/register')">{{$t("Auth.CreateAnAccount")}}</button>
                </div>
            </div>
        </div>

        <div class="header register-header" v-if="From=='Register'">
            <div class="row">
                <div class="col-12 logo">
                    <img src="/img/logo.png" alt="">
                    <button class=" button-outlined" @click="$router.push('/shop/login')">{{$t("Auth.Login")}}</button>
                </div>
            </div>
        </div>

        <div class="header inside-header" v-if="From=='Shop'">
            <div class="row">
                <div class="col-12 logo">
                    <div class="user" @click="$router.push('/shop/account')">
                        <img src="/icons_2/user.png" alt="">
                        <span class="label">{{$t("Header.Profile")}}</span>
                    </div>
                    <img src="/img/logo.png" alt="" style="cursor: pointer; margin-top: 10px" @click="$router.push('/shop')">
                    <div class="cart" @click="$router.push('/shop/cart')">
                        <span class="label">
                            {{$t("Header.Cart")}}
                            <span class="cart-qte" v-if="CartItems>0">( {{CartItems}} )</span>
                        </span>
                        <img src="/icons_2/cart.png" alt="">
                        <small class="cart-qte-mobile" v-if="CartItems>0">{{CartItems}}</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="header inside-header" v-if="From=='Cart'">
            <div class="row">
                <div class="col-12 logo">
                    <div class="user" @click="$router.push('/shop/account')">
                        <img src="/icons_2/user.png" alt="">
                        <span class="label">{{$t("Header.Profile")}}</span>
                    </div>
                    <img src="/img/logo.png" alt="" style="cursor: pointer; margin-top: 10px" @click="$router.push('/shop')">
                    <div class="cart" @click="$router.push('/shop')">
                        <span class="label">{{$t("Header.Shop")}}</span>
                        <img src="/icons_2/shop.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="header inside-header" v-if="From=='Profile'">
            <div class="row">
                <div class="col-12 logo">
                    <div class="user" @click="$router.push('/shop')">
                        <img src="/icons_2/shop.png" alt="">
                        <span class="label">{{$t("Header.Shop")}}</span>
                    </div>
                    <img src="/img/logo.png" alt="" style="cursor: pointer; margin-top: 10px" @click="$router.push('/shop')">
                    <div class="cart" @click="$router.push('/shop/cart')">
                        <span class="label">{{$t("Header.Cart")}}</span>
                        <img src="/icons_2/cart.png" alt="">
                        <span class="cart-qte" v-if="CartItems>9">+9</span>
                        <span class="cart-qte" v-else-if="CartItems>0">{{CartItems}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default({
    props:{
        From: String,
        CartItems: Number
    }
})
</script>

<style scoped>
.header{
    width: 100vw;
    height: auto;
    padding: 10px;
    background: #fff;
}
.header .logo img{
    width: 75px
}
.inside-header{
    text-align: center;
    padding: 0px 20px;
}
.inside-header .user{
    float: left;
    position: relative;
    cursor: pointer;
    padding: 10px 10px;
    border-radius: 5px;
    transition: .3s;
}
.inside-header .cart{
    float: right;
    position: relative;
    cursor: pointer;
    padding: 10px 10px;
    border-radius: 5px;
    transition: .3s;
}
.inside-header .cart span, .inside-header .user span{
    text-transform: uppercase;
    color: #ef86c1;
    font-size: 15px;
    padding: 20px 10px;
}
.inside-header .user img, .inside-header .cart img{
    width: 25px;
}
/* .inside-header .cart .cart-qte{
    background: #ef86c1;
    color: #fff;
    border-radius: 100px;
    padding: 2px;
    width: 20px;
    height: 20px;
    font-size: 10px;
    position: absolute;
    right: 10px;
    top: -7px;
} */
.inside-header .user:hover{
    background: #fa5f5f1e;
}
.inside-header .cart:hover{
    background: #fa5f5f1e;
}

.cart-qte-mobile{
    background: #ef86c1;
    color: #fff !important;
    height: 17px !important;
    width: 17px !important;
    position: fixed;
    top: 14px;
    right: 15vw;
    font-size: 10px;
    border-radius: 100px;
    display: none;
}
@media screen and (max-width: 720px){
    .inside-header .label{
        display: none;
    }
    .cart-qte-mobile{
        display: block;
    }
}
</style>